const StatsSection = () => {
  return (
    <div className="container-fluid py-5">
        <div className="container">
            <div className="row g-4">
                {[
                    { icon: "fa-check", count: "1,234", label: "Live Jobs" },
                    { icon: "fa-users-cog", count: "542", label: "Companies" },
                    { icon: "fa-users", count: "9,854", label: "Candidates" },
                    { icon: "fa-tasks", count: "1,023", label: "New Jobs Today" }
                ].map((stat, index) => (
                    <div className="col-lg-3 col-md-6 wow fadeIn" data-wow-delay={`0.${index*2+1}s`} key={index}>
                        <div className="d-flex align-items-center bg-white rounded shadow-sm p-4 border h-100">
                            <div className="bg-primary bg-opacity-10 rounded d-flex align-items-center justify-content-center me-3" style={{width: '60px', height: '60px'}}>
                                <i className={`fa ${stat.icon} fa-2x text-primary`}></i>
                            </div>
                            <div>
                                <h5 className="mb-1">{stat.count}</h5>
                                <p className="mb-0 text-muted">{stat.label}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>
  );
};

export default StatsSection;